import styled, { css } from 'styled-components';

import { Badge } from '~/components/badge/Badge';

export const ListOption = styled.li<{
  $hasV2Styles?: boolean;
  $isDisabled: boolean;
}>`
  cursor: ${props => !props.$isDisabled && 'pointer'};
  list-style-type: none;

  ${({ $hasV2Styles }) =>
    !$hasV2Styles &&
    css`
      &.focused,
      &.active,
      &:hover {
        color: var(--text-primary);

        ${Badge.Styled.BadgeTextual} {
          color: var(--text-primary);
          border-color: var(--border-primary);
        }
      }
    `}
`;
